// Central Leaflet setup — import this instead of 'leaflet' directly.
// Fixes a well-known webpack/CRA issue where Leaflet's default marker icon
// URLs (baked in relative to its own CSS) don't resolve under a bundler,
// leaving markers invisible unless re-pointed at bundler-resolved asset URLs.
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export const MAPTILER_KEY = process.env.REACT_APP_MAPTILER_KEY;

export const addMapTilerLayer = (map) => {
  L.tileLayer(
    `https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=${MAPTILER_KEY}`,
    {
      attribution:
        '© <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a> © <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }
  ).addTo(map);
};

export default L;
